export default "__VITE_ASSET__DYGGGM4m__"